import script from "./liabilityPage.vue?vue&type=script&setup=true&lang=js"
export * from "./liabilityPage.vue?vue&type=script&setup=true&lang=js"

import "./liabilityPage.vue?vue&type=style&index=0&id=6f60f240&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f60f240"]])

export default __exports__